module.exports = {
  common: {
    save: 'Lưu',
    cancel: 'Hủy',
    combinationTitle: 'Quy tắc tự động phát đơn (tổ hợp)',
    ruleTitle: 'Quy tắc tự động phát đơn',
    AutomaticOrderReleaseTriggerSettings: 'Thiết lập kích hoạt tự động phát đơn',
    ReleaseGuaranteeSetting: 'Thiết lập bảo lãnh phát đơn',
    docType: 'Loại vận đơn',
    customerSelfRelease: 'Loại HBL',
    releaseType: 'Phương thức vận đơn',
    cargoSource: 'Nguồn hàng',
    creditObject: 'Đối tượng tín dụng phát đơn',
    receivableType: 'Loại thu chi',
    creditLimitedDate: 'Kỳ hạn tín dụng',
    creditLimitAmount: 'Hạn mức tín dụng',
    customerType: 'Loại đơn vị ủy thác'
  },
  selectBranch: 'Chọn chi nhánh:',
  ApplyTheHeadOfficeConfiguration: 'Áp dụng cấu hình tổng công ty',
  enterRuleName: 'Nhập tên quy tắc',
  add: 'Thêm mới',
  edit: 'Chỉnh sửa',
  deletes: 'Xóa',
  refresh: 'Làm mới',
  ruleName: 'Tên quy tắc tự động phát đơn',
  businessTypes: 'Loại nghiệp vụ áp dụng',
  conversionRules: 'Quy tắc xử lý liên quan',
  ruleDescription: 'Mô tả',
  orderNum: 'Số thứ tự',
  ruleGroupName: 'Tên quy tắc tự động phát đơn (tổ hợp)',
  ruleNames: 'Bao gồm tên quy tắc',
  performActions: 'Bao gồm hành động thực thi',
  officeCode: 'Chi nhánh',
  customerCompany: 'Khách hàng áp dụng',
  refreshSuccess: 'Làm mới thành công',
  operationSuccess: 'Thao tác thành công',
  dialogRuleName: 'Tên quy tắc (tổ hợp)',
  RuleNamePlaceholder: 'Nhập tên quy tắc',
  ruleDescriptionPlaceholder: 'Nội dung mô tả',
  AnyRuleTitle: 'Áp dụng bất kỳ quy tắc nào sau đây',
  AllRuleTitle: 'Áp dụng tất cả các quy tắc sau đây',
  PerformRelatedActions: 'Thực hiện hành động liên quan',
  meetConditions: 'Đáp ứng điều kiện',
  meetConditionsRemind: 'Tự động phát đơn khi đáp ứng điều kiện. (Trạng thái phát đơn cập nhật thành "Có thể phát đơn")',
  dissatisfaction: 'Không đáp ứng điều kiện',
  runningRules: 'Chạy tổ hợp quy tắc tiếp theo',
  runningRulesRemind: 'Không phát đơn khi không đáp ứng điều kiện. (Trạng thái phát đơn cập nhật thành "Chờ thu tiền")',
  remark1: 'Ghi chú: Khi tất cả tổ hợp "không đáp ứng điều kiện" đều chọn "chạy tổ hợp quy tắc tiếp theo" và kết quả đánh giá thực tế đều không đáp ứng điều kiện.',
  remark2: 'Trạng thái phát đơn cũng sẽ cập nhật thành "Chờ thu tiền"',
  applicableCustomers: 'Khách hàng áp dụng',
  applicableCustomersRemind1: 'Tự động phát đơn chỉ áp dụng cho khách hàng có loại thanh toán là "không hóa đơn"',
  applicableCustomersRemind2: '(Tức là khách hàng có kỳ hạn thanh toán)',
  conditionType: 'Loại điều kiện',
  customerName: 'Tên khách hàng',
  branchOffice: 'Chi nhánh',
  successRemind: 'Lưu thành công',
  toggleReminder: 'Vui lòng xác nhận lại có chuyển đổi khách hàng áp dụng sang tất cả không? Thao tác này sẽ xóa thông tin khách hàng trong danh sách bên dưới.',
  tips: 'Thông báo',
  yes: 'Có',
  no: 'Không',
  deleteRemind: 'Vui lòng chọn ít nhất một dữ liệu để xóa!',
  ruleName1: 'Tên quy tắc',
  meetAnyConditions: 'Thỏa mãn bất kỳ điều kiện nào sau đây',
  meetAllConditions: 'Thỏa mãn tất cả các điều kiện sau',
  processingRules: 'Quy tắc xử lý phát đơn',
  releaseDemand: 'Phát đơn khi nhận tiền',
  prompt: 'Vui lòng bảo trì thông tin ${prompt} trước khi lưu.',
  Tips1: 'Vui lòng hoàn thiện thông tin quy tắc',
  equal: 'Bằng',
  neq: 'Không bằng',
  exceed: 'Vượt quá',
  notMore: 'Chưa vượt quá',
  SC: 'Tự chủ hàng',
  NC: 'Hàng chỉ định',
  creditUsedLimitAmount: 'Hạn mức đã sử dụng',
  customerIssuing: 'Khách hàng tự xuất đơn',
  issuedCompany: 'Công ty tự xuất đơn',
  original: 'Bản chính',
  telexRelease: 'Điện phát (Telex Release)',
  accountingPeriod: 'Thiết lập kỳ hạn tín dụng',
  client: 'Đơn vị ủy thác',
  agent: 'Đại lý hàng chỉ định',
  settlement: 'Đối tượng thanh toán',
  collection: 'Thu tiền',
  maintenanceName: 'Tên quy tắc (tổ hợp) bảo trì',
  rule: 'Quy tắc',
  whole: 'Tất cả',
  TriggerTheNode: 'Nút kích hoạt',
  ScheduledPollingTriggersAutomaticOrderVerification: 'Kiểm tra tự động phát đơn theo lịch trình',
  ApplyBranchOfficeSettings: 'Thiết lập chi nhánh ứng dụng',
  automatic: 'Tự động',
  daily: 'Hàng ngày',
  blacklist: 'Danh sách đen',
  EffectiveList: 'Danh sách hiệu lực',
  ChargeRecordState: 'Đánh giá tình trạng nhập chi phí',
  ChargeRecordState0: 'Phải bao gồm phí phải thu',
  ChargeRecordState1: 'Phải có chi phí đối tượng thanh toán là đơn vị ủy thác, bất kể thu',
  ChargeRecordState2: 'Có hoặc không có chi phí',
  SettlementBillMode: 'Xem mô hình thanh toán',
  SettlementBillCheckCost: 'Khi không có khoản thu nào khác, khoản thanh toán cho đơn vị ủy thác được ghi vào và được coi là đã thanh toán vé.',
  SettlementBillCustomer: 'Chỉ có đơn vị kiểm tra ủy quyền mới nhận được bán hạt nhân.',
  SettlementBillCustomerCheckCost: 'Khi đơn vị không được ủy thác nhận tiền, phải trả cho đơn vị ủy thác được ghi vào, coi như đơn vị ủy thác đã thanh toán',
  CreditObjectMode: 'Chế độ tin cậy'
}
